export const ProxyCommands = {
  CHECK_FOR_UPDATES: 'check-for-updates',
  CHECK_IS_ONLINE: 'check-is-online',
  CHECK_FAST_START_STATUS: 'check-fast-start-status',
  GET_PROXY_VERSION: 'get-proxy-version',
  GET_VERSION: 'get-version',
  GET_DEFAULT_PRINTER: 'get-default-printer',
  GET_PRINTERS: 'get-printers',
  PRINT: 'print',
  RD: 'rd:',
  RD_HELP: 'rd:help',
  RD_GET_PORTS: 'rd:get-ports',
  RD_CONNECT: 'rd:connect',
  RD_WRITE: 'rd:write',
  RD_DISPLAY: 'rd:display',
  RD_IS_PORT_OPEN: 'rd:is-port-open',
  RESET_CONTROLLER: 'reset-controller',
  SET_CONTROLLER: 'set-controller',
  SET_METER_INPUTS: 'set-meter-inputs',
  SET_ANALOG: 'set-analog',
  GET_STATUS: 'get-status',
  SET_OUTPUT: 'set-output',
  SET_OUTPUTS: 'set-outputs',
};
